// extracted by css-extract-rspack-plugin
export default {"reviewsLink":"_a9ad3a5c"};